'use es6';

import { getSettings, createGetSettings } from '../api/SurveyMonkeyApi';
import * as CacheKeys from '../constants/CacheKeys';
import createSimpleCachedReferenceResolver from '../lib/createSimpleCachedReferenceResolver';
export const createSurveyMonkeySettingReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.SURVEY_SETTINGS,
  createFetchData: createGetSettings,
  fetchData: getSettings
}, options));
export default createSurveyMonkeySettingReferenceResolver();